import { useMemo } from 'react';
import { IListing } from '../../../models/listing.model';
import { isNullOrUndefinedOrBlank } from '../../../util/isNullOrUndefinedOrBlank';
import { ListingMap } from './listing-map';
import { Walkscore } from './walkscore';
import { IBranding } from '../../../models/branding.model';

export interface NeighbourhoodProps {
  listing: IListing;
  branding: IBranding;
}

export const Neighbourhood = (props: NeighbourhoodProps) => {
  const title = useMemo(() =>
    !isNullOrUndefinedOrBlank(props.listing.community)
      ? (props.listing.community + ', ' + props.listing.city)
      : props.listing.city
    , [props.listing.community, props.listing.city]);

  return (
    <div id='neighbourhood'>
      <h2 className="title">Neighbourhood</h2>
      <Walkscore listing={props.listing} branding={props.branding} />
      <h3 className="title">This property is located in the community of {title}.</h3>
      <ListingMap mapId="neighbourhood-map" mapTypeId={google.maps.MapTypeId.HYBRID} lat={props.listing.coords.lat} lng={props.listing.coords.lng} zoomLevel={17} minZoom={14} maxZoom={20} tilt={45} streetViewControl fullScreenControl />
    </div>
  );
}
